import { createWebHistory, createRouter } from "vue-router";
import routes from "./routes";
import middleware from './middleware';

import { ziggyGetRoute as getRoute } from '@/router/ziggyGetRoute';
import store from '@/store';
import { _USER, _tenant, LoadState, ResetState } from "@/state";
import _ from "lodash";
import { LoadGames } from "../state";

const router = createRouter({
	history: createWebHistory(),
	routes,
	linkActiveClass: "active",
	linkExactActiveClass: "exact-active",
	scrollBehavior(to, from, savedPosition) {
		// always scroll to top
		return { left: 0, top: 0, behavior: "smooth" };
	},
});

//guard clause
router.beforeEach(async (...args) => {
	let [to, from, next] = args;

	// If token has expired, reload (lasts 2 hours)
	let cookies = Object.fromEntries(document.cookie.split('; ').map(v => v.split(/=(.*)/s).map(decodeURIComponent)));
	if (!Object.keys(cookies).includes('XSRF-TOKEN') && !localStorage.getItem('reload')) {
		localStorage.setItem("reload", true);
		location.reload();
	}
	if (Object.keys(cookies).includes('XSRF-TOKEN') && localStorage.getItem('reload')) {
		localStorage.removeItem("reload");
	}

	// Show 404 if no route is found
	let isErrorPage = (!!to.matched.filter(t => (t.name == 'error')).length);
	if (!(to.matched.filter(t => (t.name != 'error')).length) && !isErrorPage) {
		return next(getRoute('error', { type: 404 }));
	}

	let currentUserTenant = _tenant().slug || null;
	let requestedUserTenant = to.params.tenant || null;

	// Get User
	if (!_USER().isAuthenticated() || to.matched == 'accounts' || !currentUserTenant) {
		await store.dispatch('auth/user/showUserWithTenants');
		await store.commit('SET_APP_LOADER', false);
	}

	// Is User Verified
	middleware.verified(to, from, next);

	// Check Subscription
	if (!!requestedUserTenant && !!(to.matched.filter(t => (t.name != 'tenant.suspended')).length)) {
		try {
			await api().get(getRoute('api.test.subscribed', { tenant: requestedUserTenant }));
		} catch (error) {
			if (error.response.status == 402) {
				window.location = getRoute('tenant.suspended', { tenant: requestedUserTenant })
				return;
			}
		}
	}

	// Setup has already been completed previously
	if (currentUserTenant == requestedUserTenant) { return next(); }

	// If suspended, check if user is admin on this tenant
	if (to.name == 'tenant.suspended') {
		await store.dispatch('auth/user/showUserOnTenant', requestedUserTenant);
	}

	// If part of the tenant parent route and has tenant variable
	if (!!(to.matched.filter(t => (t.name == 'tenant')).length)) {
		await store.commit('SET_APP_LOADER', true);

		ResetState()
		await store.commit('SET_APP_LOADER', true); // TODO: Sprint-35 had removed this. Should we?
		await store.dispatch('auth/user/showUserOnTenant', to.params.tenant);

		await LoadGames();
		let games = store.state.games.all.items;

		// Load game and sprint
		let queryParam = games.filter(g => g.id == to.query.game_id)[0] ? to.query.game_id : null;
		let activeGame = queryParam ? queryParam : localStorage.activeGameId
		let sprint;

		let game;
		if (!!activeGame) game = games.filter(g => g.id == activeGame)[0];
		if (!game && games.filter(g => g.status === 'ACTIVE' && !!g.current_sprint)?.length) {
			game = games.filter(g => g.status === 'ACTIVE' && !!g.current_sprint)[0];
		}
		if (!game) game = games[0];

		if (game) {
			// Admins and player_admins can view future sprints
			if (_USER().isAble('game:create')) {
				let futureSprints = game?.sprints?.filter(s => new Date(s.time_start) > new Date()) ?? null;
				sprint = game.current_sprint
					? game.current_sprint
					: futureSprints?.length
						? futureSprints.sort((a, b) => new Date(a.time_start) - new Date(b.time_start))[0]
						: game.sprints[0];
			} else {
				sprint = game.current_sprint
					? game.current_sprint
					: game.sprint
						? game.sprint
						: game.sprints
							.filter(s => s.user_ids.includes(_USER().id))
							.sort((a, b) => new Date(b.time_start) - new Date(a.time_start))[0];
			}

			await store.dispatch('games/loadGame', { game: { id: game.id }, sprint: { id: sprint?.id ?? null } });
		}

		else {
			await LoadState()
		}

		store.commit('SET_APP_LOADER', false)
		return next();
	}
})

export default router;